import { createIcon } from './create-icon'

export const Italic = createIcon({
  displayName: 'Italic',
  paths: [
    'M682.667 298.667c23.565 0 42.667-19.103 42.667-42.667s-19.102-42.667-42.667-42.667h-256c-23.564 0-42.667 19.103-42.667 42.667s19.103 42.667 42.667 42.667h77.636l-71.113 426.667h-91.857c-23.564 0-42.667 19.102-42.667 42.667s19.103 42.667 42.667 42.667h256c23.565 0 42.667-19.102 42.667-42.667s-19.102-42.667-42.667-42.667h-77.632l71.113-426.667h91.853z'
  ]
})
